import { PluginFunction, PluginOptions } from './plugin';

const AppendTimestamp: PluginFunction = ({ method, message }: PluginOptions) => {
  if (typeof message == 'object') {
    message['timestamp'] = new Date().toISOString();
  }

  return method(message);
};

export { AppendTimestamp };
